import { lazy } from 'react';

// project import
import Loadable from './Loadable';
import MainLayout from '../layout/AdminLayout';
import MerchantPaymentinfo from '../pages/merchant_paymentinfo/MerchantPaymentinfo';
//Setting menu
const Merchant = Loadable(lazy(() => import('../pages/merchant/Merchant')));
const MerchantView = Loadable(lazy(() => import('../pages/merchant/MerchantView')));
const User = Loadable(lazy(() => import('../pages/user_admin/User')));
const SmsSending = Loadable(lazy(() => import('../pages/report/SmsSending')));
const Profile = Loadable(lazy(() => import('../pages/Profile')));

// Report
const Dashboard = Loadable(lazy(() => import('../pages/report/Dashboard')));
const Transaction = Loadable(lazy(() => import('../pages/transaction/Transaction')));
//Page not found
const PageNotFound = Loadable(lazy(() => import('../pages/PageNotFound')));


// ==============================|| MAIN ROUTING ||============================== //

const title = 'Thana admin';

const AdminRoutes = {
    element: <MainLayout />,
    children: [
        {
            path: '/dashboard_1',
            element:
                <Dashboard
                    documentTitle={`Main Dashboard - ${title}`}
                    pageTitle='Dashboard'
                    menuActive='/dashboard'
                />
        }, {
            path: '/transaction_1',
            element:
                <Transaction
                    documentTitle={`Transaction - ${title}`}
                    pageTitle='ລາຍການນໍາໃຊ້'
                    menuActive='/transaction'
                />
        }, {
            path: '/smssending',
            element:
                <SmsSending
                    documentTitle={`SMS - ${title}`}
                    pageTitle='ລາຍງານການສົ່ງ SMS'
                    menuActive='/smssending'
                />
        }, {
            path: '/merchant_paymentinfo',
            element:
                <MerchantPaymentinfo
                    documentTitle={`Merchant paymentinfo - ${title}`}
                    pageTitle='Payment provider'
                    mainMenuActive='merchant'
                    menuActive='/merchant_paymentinfo'
                />
        }, {
            path: '/merchant',
            element:
                <Merchant
                    documentTitle={`Merchant - ${title}`}
                    pageTitle='ຮ້ານຄ້າ'
                    mainMenuActive='merchant'
                    menuActive='/merchant'
                />
        }, {
            path: '/merchant/view/:mid',
            element:
                <MerchantView
                    documentTitle={`Merchant view - ${title}`}
                    pageTitle='ຮ້ານຄ້າລາຍລະອຽດ'
                    menuActive='/merchant'
                />
        }, {
            path: '/user',
            element:
                <User
                    documentTitle={`User - ${title}`}
                    pageTitle='ຂໍ້ມູນຜູ້ໃຊ້ລະບົບ'
                    mainMenuActive='user'
                    menuActive='/user'
                />
        }, {
            path: '/profile',
            element:
                <Profile
                    documentTitle={`Profile - ${title}`}
                    pageTitle='ຂໍ້ມູນສ່ວນຕົວ'
                    mainMenuActive='user'
                    menuActive='/profile'
                />
        }, {
            path: '/*',
            element: (
                <PageNotFound
                    documentTitle={`Page Not Found - ${title}`}
                    pageTitle=''
                    menuActive=''
                />
            )
        }
    ]
};

export default AdminRoutes;
